import React from 'react'
import PropTypes from 'prop-types'
import Daniel from '../../assets/images/daniel.png'
import Button from '../Button/index'

import './styles.scss'

const Banner = ({ title, body, styles }) => (
  <div className={styles ? 'banner banner--tukijat' : 'banner'}>
    <figure className="banner__image">
      <img src={Daniel} alt="Daniel" />
    </figure>
    <div className="banner__text">
      <p className="banner__text__title">{title}</p>
      <p className="banner__text__body">{body}</p>
    </div>
    <div className="banner__button">
      <Button label="Ota yhteyttä" link="/yhteys" />
    </div>
  </div>
)

export default Banner

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
}
